/**
 * <read-more-text>
 * Wraps rich text content, collapses it to a max height, and reveals the
 * rest when the "Read more" toggle is clicked. If the content doesn't
 * actually overflow the collapsed height, the toggle stays hidden.
 */
class ReadMoreText extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-read-more-content]');
    this.toggle = this.querySelector('[data-read-more-toggle]');
    if (!this.content || !this.toggle) return;

    this.moreLabel = this.toggle.dataset.moreLabel || 'Read more';
    this.lessLabel = this.toggle.dataset.lessLabel || 'Read less';

    // Wait a tick for layout/fonts to settle before measuring.
    requestAnimationFrame(() => this.#checkOverflow());
    window.addEventListener('resize', () => this.#checkOverflow());

    this.toggle.addEventListener('click', () => this.#toggleExpanded());
  }

  #checkOverflow() {
    const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
    if (!isOverflowing && !this.classList.contains('read-more--expanded')) {
      this.toggle.hidden = true;
    } else {
      this.toggle.hidden = false;
    }
  }

  #toggleExpanded() {
    const expanded = this.classList.toggle('read-more--expanded');
    this.toggle.textContent = expanded ? this.lessLabel : this.moreLabel;
    this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }
}

if (!customElements.get('read-more-text')) {
  customElements.define('read-more-text', ReadMoreText);
}
